<template>
  <div class="medias-card font-barlow">
    <TitleWidget>
      <span
        :class="
          bg === 'red'
            ? 'primary--text'
            : bg === 'green'
            ? 'secondary--text'
            : ''
        "
        >{{ title }}</span
      >
    </TitleWidget>
    <div
      @click="isPlaying = true"
      class="medias-card-overlay relative mt-5 mt-sm-7"
    >
      <v-icon size="50" color="white" class="icon">fas fa-play</v-icon>
      <img
        class="d-block relative medias-card-img"
        width="100%"
        :src="img + '?resize=1&w=600'"
      />
      <iframe
        v-if="isPlaying"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; full"
        width="100%"
        :src="video + '?autoplay=1&autohide=1&controls=0'"
        allowfullscreen
      ></iframe>
    </div>
    <div
      :style="`background-image: url(/img/bg_medias_${bg}.jpg)`"
      class="medias-card-caption py-10 px-10 d-flex justify-center flex-column"
    >
      <div class="text-center white--text font-weight-medium">{{ text }}</div>
      <div
        class="
          d-flex
          flex-column
          align-center
          justify-center
          white--text
          mt-3 mt-sm-5
        "
      >
        <span class="font-weight-bold"> Informações: </span>
        <v-btn
          :href="telLink"
          class="text-sm-h6 text-body-1 d-flex align-center white--text"
          text
        >
          <v-icon color="white">fas fa-phone-alt</v-icon>
          <span class="font-bazinga ml-2">
            {{ tel }}
          </span>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import TitleWidget from "../widgets/TitleWidget.vue";
export default {
  components: { TitleWidget },
  data: () => ({
    isPlaying: false,
  }),
  props: {
    title: {
      type: String,
      required: true,
    },
    video: {
      type: String,
      required: true,
    },
    tel: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    img: {
      type: String,
      required: true,
    },
    telLink: {
      type: String,
      required: true,
    },
    bg: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.medias-card {
  position: relative;
  &:hover {
    .icon {
      opacity: 1;
    }
  }
  .icon {
    opacity: 0.8;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 3;
  }
  iframe {
    aspect-ratio: 556 / 312;
    object-fit: cover;
    border-radius: 10px;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 10;
    pointer-events: all;
  }
  &-img {
    aspect-ratio: 556 / 312;
    object-fit: cover;
    border-radius: 10px;
    z-index: 1;
  }
  &-caption {
    margin-top: -8px;
    background-size: cover;
    border-radius: 0px 0px 10px 10px;
  }
  &-overlay {
    cursor: pointer;
    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.3);
      z-index: 2;
      border-radius: 10px;
    }
  }
}
</style>
